/* ═══════════════════════════════════════════════════════
   SPELLWISE KIDS — APP CONFIGURATION
   ═══════════════════════════════════════════════════════
   This file is your persistent settings fallback.
   Values here are used when Firebase has no settings saved.

   HOW IT WORKS:
   1. On startup the app loads settings from Firebase (spellwise/settings)
   2. If Firebase has no settings, it falls back to the values below
   3. Any settings saved via the Settings panel are written to Firebase
      and survive code redeployments automatically

   WHAT TO DO:
   - Optionally pre-fill your keys here as a fallback
   - Never commit real secrets to a public repository
   - Firebase-stored values always take priority over these
═══════════════════════════════════════════════════════ */

export const APP_CONFIG = {
  appName: 'SpellWise Kids',
  geminiKey: '',
  geminiModel: 'gemini-2.5-flash',
  rewardActionUrl: 'https://spellwise-reward-action.sarbag-bajaj.workers.dev',
  spellingWordCount: 20,
  meaningWordCount: 10,
  synonymWordCount: 10,
  antonymWordCount: 10,
  childEmails: {},
  resend: {
    apiKey: '',
    fromEmail: 'noreply@sbajaj.app',
    parent1Email: '',
    parent2Email: '',
    dailyDigest: true,
  },
  // Merriam-Webster API key — set in Cloudflare Worker environment variables
  // Get free key at dictionaryapi.com
};
